import React, { useEffect, useState, useMemo, useCallback } from "react";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import BackButton from "../../../../designUtils/Logo/BackButton.svg";
import AmazonProductListingSummaryBar from "./Components/AmazonProductListingSummaryBar";
import AmazonProductListingTabs from "./Components/AmazonProductListingTabs";
import AmazonProductListingGroupSection from "./Components/AmazonProductListingGroupSection";
import AmazonProductListingPreview from "./Components/AmazonProductListingPreview";
import CustomModal from "../../../Components/Modals/CustomModal";
import fetchProductListingDataService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchProductListingDataService";
import patchListingFieldsService from "../../../../Service/OPSServices/AmazonProductListing_v1/patchListingFieldsService";
import AmazonProductListingUpdatePopup from "./Components/AmazonProductListingUpdatePopup";
import fetchProductListingHistoryDataService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchProductListingHistoryDataService";
import ReactTable from 'react-table';
import ListingInvalidIcon from '../../../../../src/designUtils/AmazonListing/ListingInvalidIcon.svg';

import ListingValidIcon from '../../../../../src/designUtils/AmazonListing/ListingValidIcon.svg';
import { useHistory, useLocation } from "react-router-dom";
import checkSingleFeedStatusService from "../../../../Service/OPSServices/AmazonProductListing_v1/checkSingleFeedStatusService";
import notify from '../../../../Notifications/ToastifyActions';


function get(obj, path, fallback) {
  var result = obj;
  var parts = path.split(".");
  for (var i = 0; i < parts.length; i++) {
    if (result === null || result === undefined) return fallback;
    result = result[parts[i]];
  }
  return result === undefined || result === null ? fallback : result;
}

function getCounts(fields, errorFields = []) {
  fields = fields || [];
  return {
    // Check BOTH the initial status AND the live errorFields array
    errors: fields.filter(f => get(f, "validation.status", "") === "ERROR" || errorFields.includes(f.field)).length,
    warnings: fields.filter(f => get(f, "validation.status", "") === "WARNING").length,
    mandatory: fields.filter(f => get(f, "schema.is_mandatory", false)).length,
    basic: fields.filter(f => f && f.group === "basic").length,
    other: fields.filter(f => f && f.group === "other").length,
  };
}

const standardizeForComparison = (val) => {
  if (Array.isArray(val)) {
    const filtered = val
      .map(item => standardizeForComparison(item))
      .filter(item => item !== null && item !== undefined && item !== "" && !(typeof item === 'object' && Object.keys(item).length === 0));
    return filtered.length === 0 ? "" : filtered;
  }

  if (typeof val === 'object' && val !== null) {
    const cleanObj = {};
    let hasKeys = false;
    for (const key in val) {
      const cleanedVal = standardizeForComparison(val[key]);
      if (cleanedVal !== null && cleanedVal !== undefined && cleanedVal !== "") {
        cleanObj[key] = cleanedVal;
        hasKeys = true;
      }
    }
    return !hasKeys ? "" : cleanObj;
  }

  if (val === null || val === undefined) return "";

  const strVal = String(val).trim();

  if (strVal.toLowerCase() === "yes" || strVal.toLowerCase() === "true") return "true";
  if (strVal.toLowerCase() === "no" || strVal.toLowerCase() === "false") return "false";

  return strVal;
};

function AmazonProductListingMainPage(props) {
  const { token } = props;
  const history = useHistory();
  const location = useLocation();
  const [historySearch, setHistorySearch] = useState("");
  const [selectedImagesMap, setSelectedImagesMap] = useState({});
  const [originalImageMap, setOriginalImageMap] = useState({});
  const [historyLoading, setHistoryLoading] = useState(false);
  const [checkingFeedIds, setCheckingFeedIds] = useState({});
  const selectedAsin =
    (location.state && location.state.asin) ||
    props.asin;
  const selectedSku =
    (location.state && location.state.sku) ||
    props.sku;

  const storeDetails =
    (location.state && location.state.storeDetails) ||
    props.storeDetails;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("");
  const [search, setSearch] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);
  const [fields, setFields] = useState([]);
  const [previewMode, setPreviewMode] = useState(false);
  const [changedFields, setChangedFields] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveModalData, setSaveModalData] = useState(null);
  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [errorFields, setErrorFields] = useState([]);
  const [historyData, setHistoryData] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isErrorsModalOpen, setIsErrorsModalOpen] = useState(false);
  const [expandedJson, setExpandedJson] = useState({});
  const [errorsExpanded, setErrorsExpanded] = useState(true);
  const [warningsExpanded, setWarningsExpanded] = useState(true);
  const [isRestrictionsModalOpen, setIsRestrictionsModalOpen] = useState(false);

  const toggleJsonExpand = (key) => {
    setExpandedJson((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    if (!selectedAsin) return;
    setLoading(true);
    const requestData = { asin: selectedAsin, sku: selectedSku };

    fetchProductListingDataService(token, requestData).then((res) => {
      if (res.status == 'READY') {
        console.log(res);
        setData(res);
        setFields(res.fields);
        setLoading(false);
        if (
          props.setSummaryData &&
          typeof props.setSummaryData === "function"
        ) {
          props.setSummaryData(res.store.summaryList);
        }
      }
      else {
        setLoading(false);
      }


    }).catch((err) => {
      console.error(err);
      setError("Failed to load listing data.");
      setLoading(false);
    });

    const handleWindowScroll = () => {
      if (window.scrollY > 250) setIsScrolled(true);
      else if (window.scrollY < 50) setIsScrolled(false);
    };
    window.addEventListener("scroll", handleWindowScroll);
    return () => window.removeEventListener("scroll", handleWindowScroll);
  }, [token, selectedAsin, selectedSku, storeDetails]);


  useEffect(() => {
    if (data && data.propertyGroups && data.propertyGroups.length > 0) {
      setActiveTab("pg_" + data.propertyGroups[0].key);
    }
  }, [data]);

  const handlePreviewMode = (e) => setPreviewMode(e.target.checked);

  // const isListingValid = saveModalData && saveModalData.type !== "WARNING" && (!saveModalData.issues || saveModalData.issues.length === 0);
  const isListingValid =
    saveModalData &&
    saveModalData.type !== "WARNING" &&
    saveModalData.mode === "VALIDATION_PREVIEW" &&
    (!saveModalData.issues || saveModalData.issues.length === 0);
  const ORDER = [
    "Product Identity",
    "Product Details",
    "Images",
    "Variations",
    "Offer",
    "Shipping",
    "Safety & Compliance"
  ];

  const counts = useMemo(() => getCounts(fields, errorFields), [fields, errorFields]);

  const errorFieldsList = useMemo(() => {
    return (fields || []).filter(f => get(f, "validation.status", "") === "ERROR" || errorFields.includes(f.field));
  }, [fields, errorFields]);

  const warningFieldsList = useMemo(() => {
    return (fields || []).filter(f => get(f, "validation.status", "") === "WARNING");
  }, [fields]);

  const groupedErrors = useMemo(() => {
    var map = {};
    errorFieldsList.forEach(f => {
      var key = get(f, "ui.subcategory", "Other") || "Other";
      if (!map[key]) map[key] = [];
      map[key].push(f);
    });
    return map;
  }, [errorFieldsList]);

  const groupedWarnings = useMemo(() => {
    var map = {};
    warningFieldsList.forEach(f => {
      var key = get(f, "ui.subcategory", "Other") || "Other";
      if (!map[key]) map[key] = [];
      map[key].push(f);
    });
    return map;
  }, [warningFieldsList]);

  const handleRestrictions = () => {
    setIsRestrictionsModalOpen(true);
  };

  const tabs = useMemo(() => {
    const pg = (data && data.propertyGroups) || [];
    return pg
      .sort((a, b) => {
        const indexA = ORDER.indexOf(a.label);
        const indexB = ORDER.indexOf(b.label);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;

        return 0;
      })
      .map(pgItem => ({
        key: "pg_" + pgItem.key,
        label: pgItem.label,
        count: fields.filter(f =>
          get(f, "ui.subcategory", "") === pgItem.label
        ).length
      }));
  }, [fields, data]);

  const filtered = useMemo(() => {
    const pg = (data && data.propertyGroups) || [];

    return (fields || []).filter(function (f) {
      let inTab = false;

      if (previewMode) {
        inTab = true;
      } else if (activeTab.startsWith("pg_")) {
        const pgKey = activeTab.slice(3);
        const pgItem = pg.find(p => p.key === pgKey);

        inTab = pgItem
          ? get(f, "ui.subcategory", "") === pgItem.label
          : false;
      }

      return inTab && (
        !search || (f.label || "").toLowerCase().includes(search.toLowerCase())
      );
    });

  }, [fields, activeTab, search, data, previewMode]);

  var grouped = useMemo(() => {
    var map = {};
    const fieldsToGroup = previewMode ? fields : filtered;

    fieldsToGroup && fieldsToGroup.forEach(f => {
      var key = get(f, "ui.subcategory", "Other") || "Other";
      if (!map[key]) map[key] = [];
      map[key].push(f);
    });
    return map;
  }, [filtered, fields, previewMode]);

  const handleFieldChange = useCallback((update) => {
    const originalField = fields.find(f => f.field === update.field);

    let rawOriginal = null;
    let isToggle = false;

    if (originalField) {
      rawOriginal = get(originalField, "normalized_value", null);
      if (rawOriginal === null || rawOriginal === undefined || rawOriginal === "") {
        const defaultVal = get(originalField, "schema.default_value", null);
        if (defaultVal !== null && defaultVal !== undefined) {
          rawOriginal = defaultVal;
        }
      }

      const componentType = get(originalField, "render.component", "");
      const schemaType = get(originalField, "schema.type", "");
      isToggle = componentType === "TOGGLE" || schemaType === "boolean";
    }

    let origClean = standardizeForComparison(rawOriginal);
    let newClean = standardizeForComparison(update.value);

    if (isToggle) {
      origClean = (origClean === "true") ? "true" : "false";
      newClean = (newClean === "true") ? "true" : "false";
    }

    const originalValueStr = JSON.stringify(origClean);
    const newValueStr = JSON.stringify(newClean);

    if (originalValueStr === newValueStr) {
      setChangedFields(prev => {
        const updated = { ...prev };
        delete updated[update.field];
        return updated;
      });
    } else {
      setChangedFields(prev => ({ ...prev, [update.field]: update }));
    }

    setErrorFields(prevErrors => prevErrors.filter(f => f !== update.field));
  }, [fields]);
  const handleHistory = () => {
    setHistoryLoading(true);
    const requestData = { integerId: props.selectedStore, sku: selectedSku };
    fetchProductListingHistoryDataService(token, requestData).then((res) => {
      if (res) {
        console.log(res);
        setHistoryData(res.history);
        setIsHistoryModalOpen(true);
      }
      setHistoryLoading(false);

    }).catch((err) => {
      console.error(err);
      setError("Failed to load listing history data.");
      setHistoryLoading(false);
    });

  }
  const handleSave = useCallback(async () => {
    setSaving(true);
    const updates = Object.values(changedFields).map((item) => {

      const originalField = fields.find(
        f => f.field === item.field
      );

      if (!originalField) {
        return item;
      }

      const originalNormalized =
        originalField.normalized_value;

      const originalCatalog =
        get(originalField, "catalog.value", null);

      const originalListing =
        get(originalField, "listing.value", null);

      // ARRAY WRAPPER FIX
      // =========================
      const shouldWrapArray =
        Array.isArray(originalNormalized) ||
        get(originalField, "schema.rules.field_type", "") === "array";


      const listingVal = get(originalField, "listing.value", null);
      const listingArr = Array.isArray(listingVal) ? listingVal : (listingVal ? [listingVal] : []);
      const isImageField = listingArr.some(
        item => item && typeof item === "object" && "media_location" in item
      );

      let finalValue = item.value;

      if (shouldWrapArray && !Array.isArray(finalValue) && !isImageField) {
        const renderComponent = get(originalField, "render.component", "");
        const isUrlField = renderComponent === "URL_INPUT" ||
          get(originalField, "schema.rules.format", "") === "uri";
        if (!isUrlField) {
          finalValue = [finalValue];
        }
      }
      return {
        field: item.field,
        value: finalValue
      };
    });

    if (updates.length === 0) {
      setSaveModalData({ type: "WARNING", message: "Not Updated! No fields were changed." });
      setIsSaveModalOpen(true);
      setSaving(false);
      return;
    }

    const requestData = {
      asin: selectedAsin,
      sku: selectedSku,
      mode: "VALIDATION_PREVIEW",
      updates: updates
    };

    const res = await patchListingFieldsService(token, requestData);

    if (res) {
      setSaveModalData(res);
      setIsSaveModalOpen(true);

      if (res.issues && res.issues.length > 0) {
        const errored = res.issues.flatMap(i => i.attributeNames || []).filter(Boolean);
        setErrorFields(errored.length > 0 ? errored : updates.map(u => u.field));
      } else {
        setErrorFields([]);
        // setChangedFields({});
      }
    }
    setSaving(false);
  }, [changedFields, fields, selectedAsin, selectedSku, token]);

  const handleUpdate = useCallback(async () => {
    setSaving(true);
    const updates = Object.values(changedFields).map((item) => {
      const originalField = fields.find(f => f.field === item.field);
      if (!originalField) return item;

      const originalNormalized = originalField.normalized_value;
      const shouldWrapArray =
        Array.isArray(originalNormalized) ||
        get(originalField, "schema.rules.field_type", "") === "array";

      const listingVal = get(originalField, "listing.value", null);
      const listingArr = Array.isArray(listingVal) ? listingVal : (listingVal ? [listingVal] : []);
      const isImageField = listingArr.some(
        item => item && typeof item === "object" && "media_location" in item
      );

      let finalValue = item.value;
      if (shouldWrapArray && !Array.isArray(finalValue) && !isImageField) {
        const renderComponent = get(originalField, "render.component", "");
        const isUrlField = renderComponent === "URL_INPUT" ||
          get(originalField, "schema.rules.format", "") === "uri";
        if (!isUrlField) {
          finalValue = [finalValue];
        }
      }
      return { field: item.field, value: finalValue };
    });

    if (updates.length === 0) {
      setSaveModalData({ type: "WARNING", message: "No fields were changed." });
      setIsSaveModalOpen(true);
      setSaving(false);
      return;
    }

    const requestData = {
      asin: selectedAsin,
      sku: selectedSku,
      mode: "LIVE",
      updates: updates
    };

    const res = await patchListingFieldsService(token, requestData);

    if (res) {
      setSaveModalData(res);
      if (!res.issues || res.issues.length === 0) {
        setChangedFields({});
        setErrorFields([]);
        setFields(prevFields =>
          prevFields.map(f => {
            const updated = updates.find(u => u.field === f.field);
            if (!updated) return f;
            return {
              ...f,
              normalized_value: updated.value,
              listing: {
                ...f.listing,
                value: updated.value
              }
            };
          })
        );
      }
    }
    setSaving(false);
    setIsSaveModalOpen(true);
  }, [changedFields, fields, selectedAsin, selectedSku, token]);

  var handleAutoFix = useCallback(() => { alert("Auto Fix triggered"); }, []);

  const filteredHistoryData = useMemo(() => {
    if (!historySearch) return historyData;

    return historyData.filter((row) =>
      Object.values(row || {}).some((value) =>
        String(value || "")
          .toLowerCase()
          .includes(historySearch.toLowerCase())
      )
    );
  }, [historyData, historySearch]);
  // if (loading) return <div className="listing-page-loading mt-5 text-center">Loading listing data&hellip;</div>;
  if (loading) return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "70vh", gap: "16px" }}>
      <div className="spinner-border" role="status" style={{ width: "2rem", height: "2rem", color: "#4d83fc" }}>
        <span className="sr-only">Loading...</span>
      </div>
      <p style={{ fontSize: "18px", color: "#555", fontWeight: "500", margin: 0 }}>Loading listing data...</p>
    </div>
  );
  if (error) return <div className="listing-page-error mt-5 text-center text-danger">{error}</div>;

  var displayAsin = (data && data.asin) || selectedAsin || "\u2014";
  var sku = (data && data.sku) || "\u2014";
  var productType = (data && data.productType) || "\u2014";

  const renderInputOutputJSON = (data, isRoot = true) => {
    if (data === null || data === undefined) return "-";

    if (typeof data !== "object") return <span>{String(data)}</span>;

    const ulStyle = isRoot
      ? { listStyleType: "none", padding: 0, margin: 0, fontSize: "12px", textAlign: "left" }
      : { listStyleType: "none", paddingLeft: "12px", margin: 0 };

    if (Array.isArray(data)) {
      return (
        <ul style={ulStyle}>
          {data.map((item, index) => (
            <li key={index} style={{ marginBottom: "4px" }}>
              {renderInputOutputJSON(item, false)}
            </li>
          ))}
        </ul>
      );
    }

    return (
      <ul style={ulStyle}>
        {Object.entries(data).map(([key, value]) => (
          <li key={key} style={{ marginBottom: "2px", wordBreak: "break-word" }}>
            <span style={{ fontWeight: "600", color: "#333" }}>{key} : </span>
            {renderInputOutputJSON(value, false)}
          </li>
        ))}
      </ul>
    );
  };

  const handleCheckFeedStatus = async (row) => {
    const feedId = row.outputJson && row.outputJson.feedId;
    if (!feedId || checkingFeedIds[feedId]) return;

    setCheckingFeedIds(prev => ({ ...prev, [feedId]: true }));

    const requestData = {
      asin: row.asin || selectedAsin,
      sku: row.sku || selectedSku,
      feed_id: feedId,
      integerId: props.selectedStore,
    };

    try {
      const res = await checkSingleFeedStatusService(token, requestData);
      if (res && res.status) {
        // Only update historyData if feed reached terminal state
        if (res.db_updated) {
          setHistoryData(prev =>
            prev.map(item =>
              item.outputJson && item.outputJson.feedId === feedId
                ? {
                  ...item,
                  status: res.status,
                  updatedOn: res.updated_on || item.updatedOn,
                  outputJson: {
                    ...item.outputJson,
                    internalStatus: res.status,
                    ...(res.raw_report && { amazonReport: res.raw_report }),
                  }
                }
                : item
            )
          );
        } else {
          // IN_PROGRESS / IN_QUEUE — only status text update ,not touch  outputJson 
          setHistoryData(prev =>
            prev.map(item =>
              item.outputJson && item.outputJson.feedId === feedId
                ? { ...item, status: res.status }
                : item
            )
          );
        }

        // Show toast based on new internal status
        if (res.status === "IN_QUEUE") {
          notify.NotifyWarning("Your listing update is queued on Amazon. Processing will begin shortly.");

        } else if (res.status === "IN_PROGRESS") {
          notify.NotifyWarning("Your listing update is currently being processed by Amazon. Please check back in a few minutes.");

        } else if (res.status === "SUCCESS") {
          notify.NotifySuccess("Your listing has been successfully updated on Amazon!");

        } else if (res.status === "SUCCESS_WITH_WARNINGS") {
          notify.NotifyWarning("Amazon processed the feed with some warnings. Please review the details.");

        } else if (res.status === "PARTIAL_SUCCESS") {
          notify.NotifyWarning("Amazon processed the feed but some records failed. Please review the details.");

        } else if (res.status === "FAILED") {
          notify.NotifyError("Amazon processed the feed but all records failed. Please re-submit.");

        } else if (res.status === "FATAL") {
          notify.NotifyError("Amazon rejected this feed entirely. Please re-submit your listing update.");

        } else if (res.status === "CANCELLED") {
          notify.NotifyWarning("This feed was cancelled by Amazon before processing. Please re-submit.");

        } else {
          notify.NotifyError(`Unexpected status received: ${res.status}`);
        }
      }
    } catch (err) {
      console.error(err);
    }

    setCheckingFeedIds(prev => ({ ...prev, [feedId]: false }));
  };
  const historyColumns = [
    {
      Header: "Input JSON",
      accessor: "inputJson",
      Cell: (cellInfo) => {
        const cellKey = `input-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "89px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Output JSON",
      accessor: "outputJson",
      Cell: (cellInfo) => {
        const cellKey = `output-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "89px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Mode",
      accessor: "mode",
      width: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   width: 100,
    //   Cell: (cellInfo) => (
    //     <div className="d-flex justify-content-center align-items-center w-100">
    //       <p className={`m-0 fw-bold ${cellInfo.value === 'VALID' ? 'text-success' : 'text-danger'}`}>
    //         {cellInfo.value || "-"}
    //       </p>
    //     </div>
    //   )
    // },

    {
      Header: "Created By",
      accessor: "updatedBy",
      width: 150,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      width: 160,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Updated On",
      accessor: "updatedOn",
      width: 160,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center align-items-center w-100">
          <p className="m-0">{cellInfo.value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      width: 170,
      Cell: (cellInfo) => {
        const status = cellInfo.value;

        // Only IN_PROGRESS or IN_QUEUE are clickable
        const isClickable = status === "IN_PROGRESS" || status === "IN_QUEUE";
        const row = cellInfo.row._original;
        const feedId = row.outputJson && row.outputJson.feedId;
        const isChecking = feedId && checkingFeedIds[feedId];

        // Color logic based on status
        const getStatusColor = (s) => {
          if (["SUCCESS", "ACCEPTED", "VALID"].includes(s)) return "text-success";
          if (["SUCCESS_WITH_WARNINGS", "IN_PROGRESS", "IN_QUEUE"].includes(s)) return "text-warning";
          if (["FAILED", "PARTIAL_SUCCESS", "FATAL", "INVALID", "ERROR"].includes(s)) return "text-danger";
          if (s === "CANCELLED") return "text-secondary";
          return "text-dark";
        };

        return (
          <div className="d-flex justify-content-center align-items-center w-100">
            <p
              className={`m-0 fw-bold ${getStatusColor(status)}`}
              style={{
                cursor: isClickable && !isChecking ? "pointer" : "default",
                textDecoration: isClickable && !isChecking ? "underline" : "none",
                opacity: isChecking ? 0.5 : 1,
                pointerEvents: isChecking ? "none" : "auto",
                fontSize: "12px"  // slightly smaller — status text lamba asto
              }}
              title={isClickable && !isChecking ? "Click to update status" : ""}
              onClick={() => {
                if (isClickable && !isChecking) handleCheckFeedStatus(row);
              }}
            >
              {isChecking ? "Updating..." : status || "-"}
            </p>
          </div>
        );
      },
    }

  ];

  const formatValue = (val) => {
    if (!val) return "";

    // If array
    if (Array.isArray(val)) {
      return val
        .map(item => {
          // If object with value key (MOST IMPORTANT CASE)
          if (typeof item === "object" && item.value !== undefined) {
            return item.value;
          }

          // If dimension type object
          if (typeof item === "object") {
            return Object.entries(item)
              .map(([k, v]) => {
                if (v && v.value !== undefined) {
                  return `${k}: ${v.value} ${v.unit || ""}`;
                }
                return `${k}: ${v}`;
              })
              .join(" | ");
          }

          return item;
        })
        .join(" | ");
    }

    // If object
    if (typeof val === "object") {
      return Object.entries(val)
        .map(([k, v]) => {
          if (v && v.value !== undefined) {
            return `${k}: ${v.value} ${v.unit || ""}`;
          }
          return `${k}: ${v}`;
        })
        .join(" | ");
    }

    return val;
  };

  const handleDownload = () => {
    if (!fields || fields.length === 0) return;

    const header = ["Field", "Catalog", "Listing"];

    const rows = fields.map(f => [
      f.label || f.field,
      formatValue(f.catalog && f.catalog.value),
      formatValue(f.listing && f.listing.value)
    ]);

    const csvContent =
      [header, ...rows]
        .map(row =>
          row.map(val => {
            if (!val) return '""';

            const cleaned = String(val)
              .replace(/"/g, '""')      // escape quotes
              .replace(/\n/g, " ")      // remove new lines
              .replace(/\r/g, " ");

            return `"${cleaned}"`;      // wrap in quotes
          }).join(",")
        )
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const today = new Date().toISOString().split("T")[0];
    link.download = `Amazon_Listing_Catalog_${selectedAsin}_${today}.csv`;
    link.click();
  };
  const variationTheme =
    fields && fields.find(f => f.field === "variation_theme")
      ? fields.find(f => f.field === "variation_theme").normalized_value
      : "";
  return (
    <div className="listing-container">
      <div className='sticky-header-container'>
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <button
              className="back-button-header mr-3"
              onClick={() => {

                if (props.onBack && !(location.state && location.state.backRoute)) {
                  props.onBack();
                  return;
                }

                if (location.state && location.state.backRoute) {
                  history.push(location.state.backRoute);
                  return;
                }

                history.goBack();
              }}
              style={{ padding: 0, border: 'none', background: 'transparent' }}
            >
              <img src={BackButton} alt="Back" />
            </button>

            <h4 className="listing-page-title mb-0" style={{ fontWeight: 'bold' }}>
              Update Listing
            </h4>
          </div>

          <div className="d-flex align-items-center">
            <Button className="btn-background-color-action-settings mr-3"
              onClick={handleDownload}
              disabled={loading}>
              <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: '17px', marginRight: '10px' }} icon={faDownload} />
              {loading ? "Processing..." : "Download"}
            </Button>
            <Button onClick={handleRestrictions} className="mr-3 restriction-btn">
              Restrictions
            </Button>
            <Button
              onClick={handleHistory}
              className="btn-background-color-Proceed-gallery mr-3"
              disabled={historyLoading}
            >
              {historyLoading ? "Loading..." : "History"}
            </Button>

            <div className="d-flex align-items-center">
              <span className="custom-label mr-2 mb-0" style={{ fontWeight: '500' }}>Review :</span>
              <label className="toggle-switch mb-0">
                <input type="checkbox" checked={previewMode} onChange={handlePreviewMode} />
                <span className="dot"></span>
              </label>
            </div>

            {/* <Button 
              className="delete-button-background-none"
              onClick={() => setIsErrorsModalOpen(true)}
            >
              Errors ({counts.errors + counts.warnings})
            </Button> */}
          </div>
        </div>

        <div className="amazon-listing-header-card mb-3 w-100 d-flex justify-content-between align-items-center">
          <span><span><b>ASIN : </b></span>{displayAsin}  {props.isParentProduct ? (
            <span> (Parent)</span>
          ) : data && data.parentAsin === "-" ||
            String(data && data.parentAsin).toLowerCase() === "orphan" ? (
            <span> (Orphan)</span>
          ) : null}
          </span>
          <span><span><b>Store Name : </b></span>{storeDetails && storeDetails.name}</span>
          <span><span><b>SKU : </b></span>{selectedSku}</span>
          <span><span><b>Type : </b></span>{productType}</span>
        </div>
        <div
          className="mb-3"
          style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap"
          }}
        >
          <span className="variation-badge">
            Variation Theme : <b>{variationTheme || "-"}</b>
          </span>

          <span className="variation-badge">
            Parent ASIN : <b>{data && data.parentAsin || "-"}</b>
          </span>

          <span className="variation-badge">
            Child : <b>{data && data.childCount || 0}</b>
          </span>
        </div>


        {/* <div className={`summary-collapsible mb-3 ${isScrolled ? "hidden" : ""}`}>
          <AmazonProductListingSummaryBar summary={data && data.summary} />
        </div> */}

        <div className="d-flex justify-content-between align-items-start w-100">

          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <AmazonProductListingTabs
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              search={search}
              setSearch={setSearch}
              previewMode={previewMode}
            />
          </div>
        </div>
      </div>

      <div className="scrollable-content">
        {filtered.length === 0 ? (
          <div className="empty-state p-3 text-center">No fields found.</div>
        ) : previewMode ? (
          <AmazonProductListingPreview
            groupedFields={grouped}
            changedFields={changedFields}
            storeName={storeDetails && storeDetails.name ? storeDetails.name : "Store"}
            asin={displayAsin}
            sku={sku}
          />
        ) : (
          Object.keys(grouped).map(group => (
            <AmazonProductListingGroupSection
              key={group}
              title={group}
              fields={grouped[group]}
              setFields={setFields}
              data={data}
              onFieldChange={handleFieldChange}
              errorFields={errorFields}
              changedFields={changedFields}
              selectedAsin={selectedAsin}
              token={token}
              sku={selectedSku}
              allFields={fields}
              isParentProduct={props.isParentProduct}
              selectedImagesMap={selectedImagesMap}
              setSelectedImagesMap={setSelectedImagesMap}
              originalImageMap={originalImageMap}
              setOriginalImageMap={setOriginalImageMap}
            />
          ))
        )}
      </div>
      {activeTab !== "pg_variations" && (
        <div className="listing-page-actions d-flex justify-content-end align-items-end mt-4 mb-4">
          <Button onClick={handleSave} className="btn-background-color-Proceed-gallery" disabled={saving || Object.keys(changedFields).length === 0}>
            {saving ? 'Validating...' : 'Validate'}
          </Button>
          {/* <Button onClick={handleAutoFix} className="btn-secondary ml-3">Auto Fix</Button> */}
        </div>)}

      <CustomModal
        header={
          saveModalData && saveModalData.mode === "LIVE"
            ? "Patch Listing"
            : saveModalData && saveModalData.issues && saveModalData.issues.length > 0
              ? "Validate Listing"
              : "Validate Listing"
        }
        isOpen={isSaveModalOpen}
        toggle={() => {
          setIsSaveModalOpen(!isSaveModalOpen)
          if (
            saveModalData &&
            saveModalData.mode === "LIVE" &&
            (!saveModalData.issues || saveModalData.issues.length === 0)
          ) {
            setChangedFields({});
          }
        }
        }
        size={"lg"}
        className="curve-popup"
      >
        <div className="p-3" style={{ minHeight: '150px' }}>
          {saveModalData && saveModalData.type === "WARNING" ? (
            <div className="text-warning fw-bold fs-5 text-center mt-4">
              {saveModalData.message}
            </div>
          ) : saveModalData && saveModalData.mode === "LIVE" ? (

            /* ── RESTORED LIVE UPDATE UI ── */
            <div>
              {/* Success / Fail banner */}
              {saveModalData.status === "ACCEPTED" ? (
                <div className="d-flex align-items-center justify-content-center mb-3"
                  style={{ background: '#117200', borderRadius: '14px', padding: '15px 20px' }}>
                  <img src={ListingValidIcon} alt="Success" width="28" height="28" style={{ marginRight: '10px' }} />
                  <span style={{ color: '#ffffff', fontWeight: 'bold', fontSize: '16px' }}>
                    Listing updated successfully on Amazon!
                  </span>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center mb-3"
                  style={{ background: '#CC0000', borderRadius: '14px', padding: '15px 20px' }}>
                  <img src={ListingInvalidIcon} alt="Error" width="28" height="28" style={{ marginRight: '10px' }} />
                  <span style={{ color: '#ffffff', fontWeight: 'bold', fontSize: '16px' }}>
                    Update failed. Please try again.
                  </span>
                </div>
              )}

              {/* Updated fields list */}
              {saveModalData.updated_fields && saveModalData.updated_fields.length > 0 && (
                <div className=" p-3 shadow-sm" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '14px' }}>
                  <h6 className="text-dark fw-bold mb-3" style={{ fontSize: '14px' }}>
                    Updated Fields ({saveModalData.updated_fields.length}):
                  </h6>
                  {saveModalData.updated_fields.map((f, idx) => (
                    <div key={idx} className="d-flex align-items-start mb-2 pb-2"
                      style={{ borderBottom: idx < saveModalData.updated_fields.length - 1 ? '1px solid #dee2e6' : 'none' }}>
                      <span style={{ fontSize: 14, marginRight: 8, marginTop: 1 }}>
                        {f.status === "VALID" ? (
                          <img src={ListingValidIcon} alt="Valid" width="16" height="16" />
                        ) : (
                          <img src={ListingInvalidIcon} alt="Invalid" width="16" height="16" />
                        )}
                      </span>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 'bold', fontSize: 13, color: '#333' }}>{f.field}</div>
                        <div style={{ fontSize: 12, color: '#555', marginTop: 2, wordBreak: 'break-word' }}>
                          {JSON.stringify(f.value, null, 2)}
                        </div>
                      </div>
                      <span style={{
                        fontSize: 11, padding: '4px 10px 2px 10px', borderRadius: '10px', marginLeft: 8, whiteSpace: 'nowrap',
                        background: f.status === "VALID" ? '#117200' : '#CC0000',
                        color: '#ffffff',
                        fontWeight: 'bold'
                      }}>
                        {f.status}
                      </span>
                    </div>
                  ))}
                </div>
              )}

              {/* Issues list */}
              {saveModalData.issues && saveModalData.issues.length > 0 && (
                <div className="mx-2 mt-3 p-3 shadow-sm" style={{ backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '14px' }}>
                  <h6 className="fw-bold mb-2" style={{ fontSize: '13px', color: '#856404' }}>Issues:</h6>
                  {saveModalData.issues.map((issue, idx) => (
                    <div key={idx} style={{ fontSize: 12, color: '#856404', marginBottom: 4 }}>
                      • {issue.message || JSON.stringify(issue)}
                    </div>
                  ))}
                </div>
              )}
            </div>

          ) : saveModalData ? (
            <AmazonProductListingUpdatePopup
              data={saveModalData}
              onUpdate={handleUpdate}
              isListingValid={isListingValid}
              saving={saving}
              mode={saveModalData.mode}
            />
          ) : null}
        </div>
      </CustomModal>
      <CustomModal
        isOpen={isHistoryModalOpen}
        toggle={() => setIsHistoryModalOpen(!isHistoryModalOpen)}
        size="xl"
        className="curve-popup"
        header={
          <span style={{ fontSize: "17px" }}>
            <b>ASIN:</b> {displayAsin} | <b>SKU:</b> {selectedSku || "-"}
          </span>
        }
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Amazon Listing History</h4>
            <input
              type="text"
              className="form-control"
              placeholder="Search..."
              value={historySearch}
              onChange={(e) => setHistorySearch(e.target.value)}
              style={{ maxWidth: "300px" }}
            />
          </div>

          <ReactTable
            data={filteredHistoryData}
            columns={historyColumns}
            className="-fixed -highlight -striped mt-2"
            getTheadProps={() => ({
              style: {
                overflowY: "hidden",
                background: "#B1FA63",
                color: "#243837",
              },
            })}
            defaultPageSize={5}
            noDataText={"No History Data Found."}
          />
        </div>
      </CustomModal>
      <CustomModal
        isOpen={isErrorsModalOpen}
        toggle={() => setIsErrorsModalOpen(!isErrorsModalOpen)}
        size="xl"
        className="curve-popup"
        header="Errors & Warnings"
      >
        <div className="p-3" style={{ minHeight: '300px' }}>

          {/* ERRORS SECTION */}
          <div className="mb-4">
            <div
              onClick={() => setErrorsExpanded(!errorsExpanded)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#E2E5E9', /* Darker than #F0F2F5 */
                padding: '12px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                marginBottom: errorsExpanded ? '16px' : '0',
                transition: 'background-color 0.2s ease'
              }}
            >
              <h6 style={{ fontWeight: 'bold', color: '#000000', fontSize: '16px', margin: 0 }}>
                Errors ({errorFieldsList.length})
              </h6>
              {/* Updated Chevron Here */}
              <span style={{ fontSize: '14px', color: '#000000' }}>
                {errorsExpanded ? '▼' : '▶'}
              </span>
            </div>

            {errorsExpanded && (
              <div>
                {errorFieldsList.length > 0 ? (
                  Object.keys(groupedErrors).map(group => (
                    <AmazonProductListingGroupSection
                      key={`err-${group}`}
                      title={group}
                      fields={groupedErrors[group]}
                      setFields={setFields}
                      data={data}
                      onFieldChange={handleFieldChange}
                      errorFields={errorFields}
                      changedFields={changedFields}
                      selectedAsin={selectedAsin}
                      token={token}
                      sku={selectedSku}
                      allFields={fields}
                      selectedImagesMap={selectedImagesMap}
                      setSelectedImagesMap={setSelectedImagesMap}
                      originalImageMap={originalImageMap}
                      setOriginalImageMap={setOriginalImageMap}
                    />
                  ))
                ) : (
                  <div className="p-3 text-center text-muted" style={{ border: '1px dashed #ccc', borderRadius: '6px', backgroundColor: '#fff' }}>
                    No fields found.
                  </div>
                )}
              </div>
            )}
          </div>

          {/* WARNINGS SECTION */}
          <div className="mb-4">
            <div
              onClick={() => setWarningsExpanded(!warningsExpanded)}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: '#E2E5E9', /* Darker than #F0F2F5 */
                padding: '12px 16px',
                borderRadius: '6px',
                cursor: 'pointer',
                marginBottom: warningsExpanded ? '16px' : '0',
                transition: 'background-color 0.2s ease'
              }}
            >
              <h6 style={{ fontWeight: 'bold', color: '#000000', fontSize: '16px', margin: 0 }}>
                Warnings ({warningFieldsList.length})
              </h6>
              {/* Updated Chevron Here */}
              <span style={{ fontSize: '14px', color: '#000000' }}>
                {warningsExpanded ? '▼' : '▶'}
              </span>
            </div>

            {warningsExpanded && (
              <div>
                {warningFieldsList.length > 0 ? (
                  Object.keys(groupedWarnings).map(group => (
                    <AmazonProductListingGroupSection
                      key={`warn-${group}`}
                      title={group}
                      fields={groupedWarnings[group]}
                      setFields={setFields}
                      data={data}
                      onFieldChange={handleFieldChange}
                      errorFields={errorFields}
                      changedFields={changedFields}
                      selectedAsin={selectedAsin}
                      token={token}
                      sku={selectedSku}
                      allFields={fields}
                      selectedImagesMap={selectedImagesMap}
                      setSelectedImagesMap={setSelectedImagesMap}
                      originalImageMap={originalImageMap}
                      setOriginalImageMap={setOriginalImageMap}
                    />
                  ))
                ) : (
                  <div className="p-3 text-center text-muted" style={{ border: '1px dashed #ccc', borderRadius: '6px', backgroundColor: '#fff' }}>
                    No fields found.
                  </div>
                )}
              </div>
            )}
          </div>

        </div>
      </CustomModal>
      {/* Restrictions Modal */}
      <CustomModal
        isOpen={isRestrictionsModalOpen}
        toggle={() => setIsRestrictionsModalOpen(!isRestrictionsModalOpen)}
        size="lg"
        className="curve-popup"
        header="Restrictions"
      >
        <div className="p-3">
          {data && data.restrictions && data.restrictions.messages && data.restrictions.messages.length > 0 ? (
            <div>
              {data.restrictions.is_blocked && (
                <div>
                  <span className="fw-bold">
                    This product is not eligible for listing.
                  </span>
                </div>
              )}

              <h6 className="fw-bold mb-3 text-dark">
                Restriction Details ({data.restrictions.messages.length}):
              </h6>

              {data.restrictions.messages.map((res, idx) => (
                <div key={idx} className="alert alert-warning mb-3 shadow-sm">
                  <div className="fw-bold mb-1">
                    Reason Code: {res.code || "UNKNOWN"}
                  </div>
                  <div className="text-muted small">
                    {res.message || "No specific message provided by Amazon."}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center">
              <div>
                No restrictions found. You are eligible to list this product.
              </div>
            </div>
          )}
        </div>
      </CustomModal>
    </div>
  );
}

const mapStateToProps = (state) => ({ token: state.loggedUser.token });
export default connect(mapStateToProps)(AmazonProductListingMainPage);